import React from 'react';

import classes from './InfoBlock.module.scss';

type InfoBlockProps = {
  title: string;
  descriptions: string[];
  note?: string;
};

const InfoBlock = ({ title, descriptions, note }: InfoBlockProps) => {
  return (
    <div className={classes.box}>
      <h5 className={classes.title}>{title}</h5>
      {descriptions.map((item) => (
        <p className={classes.description} key={item}>
          {item}
        </p>
      ))}
      {note && <i className={classes.note}>{note}</i>}
    </div>
  );
};

export { InfoBlock };
